import React, { useEffect, useState } from "react";

import AspectWrapper from "core-web/components/AspectWrapper";
import PropTypes from "prop-types";
import { inServer } from "core-web/constants";
import { media } from "core-web/utils/mediaqueries";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    position: relative;
    width: 100%;
    height: 100%;

    & > div {
        height: 100%;
    }
    & > img,
    svg {
        margin: auto;
    }

    & > svg {
        filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
        transition: all 250ms ease-in-out;
    }

    ${media.hover} {
        &:hover svg {
            /* @TODO hover for video */
        }
    }

    &:hover {
        cursor: pointer;
    }
`;

const Thumbnail = styled("img")``;

const Iframe = styled("iframe")`
    position: absolute;
    top: 0;
`;

const Youtube = ({ children, embedUrl, thumbnailSrc, ratio, showVideoByDefault, autoplayVideo, ...rest }) => {
    const [showVideo, setShowVideo] = useState(showVideoByDefault);

    useEffect(() => {
        const iframe = inServer ? [] : document.getElementById(embedUrl);

        const startVideo = () => {
            //For video to autoplay in mobile-devices, we need to send playVideo to the content-window, sending autoplay=1 in url only autoplays for desktop. This solution covers both.
            iframe && iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
        };

        if (showVideo && autoplayVideo) {
            //waits for video in iframe to finnish loading before executing autoplay command.
            iframe.addEventListener("load", () => startVideo());
        }

        return () => iframe && iframe.removeEventListener("load", startVideo);
    }, [showVideo]);

    return (
        <Wrapper onClick={() => setShowVideo(true)} {...rest}>
            <AspectWrapper ratio={ratio}>
                {showVideo ? (
                    <Iframe
                        allowFullScreen
                        width="100%"
                        height="100%"
                        id={embedUrl}
                        //For autoplay to work on iOS we need to send the mute=1 in src-url to player, iOS can't autoplay with sound, but it's possible for android. enablejsapi=1 is for postMessage() to work.
                        src={`${embedUrl}?mute=1&enablejsapi=1`}
                        frameBorder="0"
                        className="ifrm"
                        rel="0"
                        allow="autoplay; encrypted-media"
                        title="Youtube video"
                        borderRadius="12px"
                    />
                ) : (
                    <>
                        {thumbnailSrc && (
                            <Thumbnail height="100%" width="100%" src={thumbnailSrc} alt="Youtube video" />
                        )}
                        {children}
                    </>
                )}
            </AspectWrapper>
        </Wrapper>
    );
};

Youtube.propTypes = {
    autoplayVideo: PropTypes.bool,
    children: PropTypes.object,
    embedUrl: PropTypes.string.isRequired,
    ratio: PropTypes.number,
    showVideoByDefault: PropTypes.bool,
    thumbnailSrc: PropTypes.string,
};

Youtube.defaultProps = {
    autoplayVideo: false,
    ratio: 16 / 9,
    children: null,
    showVideoByDefault: false,
};

export default Youtube;
